<template>
  <div>
    <form>
      <div class="row">
        <div class="col-md-12"></div>

        <div class="col-md-2">
          <fg-input
            class="clean"
            type="text"
            label="Inclusão (R$)"
            placeholder="$$$"
            v-on:input="formatAdd"
            v-model="data.formattedAddCentavos"
            v-bind:readonly="readonly"
          />
        </div>

        <div class="col-md-2">
          <fg-input
            class="clean"
            type="text"
            label="Marcação (R$)"
            placeholder="$$$"
            v-on:input="formatMark"
            v-model="data.formattedMarkCentavos"
            v-bind:readonly="readonly"
          />
        </div>

        <div class="col-md-2">
          <fg-input
            class="clean"
            type="text"
            label="Reserva (R$)"
            placeholder="$$$"
            v-on:input="formatReserve"
            v-model="data.formattedReserveCentavos"
            v-bind:readonly="readonly"
          />
        </div>

        <div class="col-md-2">
          <fg-input
            class="clean"
            type="text"
            label="Oferta (R$)"
            placeholder="$$$"
            v-on:input="formatAuction"
            v-model="data.formattedAuctionCentavos"
            v-bind:readonly="readonly"
          />
        </div>

        <div class="col-md-2">
          <fg-input
            class="clean"
            type="Number"
            max="24"
            min="0"
            label="Duração em Horas da Reserva"
            placeholder="Horas"
            v-model="data.reserveHours"
            v-bind:readonly="readonly"
          />
        </div>
        <div class="col-md-2">
          <fg-input
            class="clean"
            type="Number"
            min="0"
            label="Duração em Dias do Leilão"
            placeholder="Dias"
            v-model="data.deadLineDays"
            v-bind:readonly="readonly"
          />
        </div>
        <div class="col-md-2">
          <fg-input
            class="clean"
            type="Number"
            max="24"
            min="0"
            label="Duração em Horas do Leilão"
            placeholder="Horas"
            v-model="data.deadLineHours"
            v-bind:readonly="readonly"
          />
        </div>
        <div class="col-md-2">
          <fg-input
            class="clean"
            type="Number"
            max="100"
            min="0"
            label="Porcentagem do Valor Inicial do Leilão"
            placeholder="60"
            :keyUP="updatePercentAuction()"
            v-model="data.initialAuctionPercent"
            v-bind:readonly="readonly"
          />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  name: "service-form",

  props: {
    data: {
      type: Object,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    event: {
      type: String,
      default: "",
    },
  },

  methods: {
    ...mapGetters({
      sidebarFlag: "sidebarFlag",
    }),

    updatePercentAuction() {
      if (this.data.initialAuctionPercent < 0) {
        this.data.initialAuctionPercent = 0;
      } else if (this.data.initialAuctionPercent > 100) {
        this.data.initialAuctionPercent = 100;
      }
    },

    unlock() {
      if (this.sidebarFlag() === "ADMIN") {
        this.localReadonly = !this.localReadonly;
      } else {
        this.localReadonly = true;
      }
    },

    formatAdd: function(sValue) {
      this.data.formattedAddCentavos = parseInt(
        ("" + sValue).onlyNumber()
      ).int2Money();
      this.data.addCentavos = this.data.formattedAddCentavos
        .replace("R$", "")
        .replace(",", "")
        .replace(".", "")
        .replace(" ", "");

      this.$nextTick(() => {});
    },

    formatMark: function(sValue) {
      this.data.formattedMarkCentavos = parseInt(
        ("" + sValue).onlyNumber()
      ).int2Money();
      this.data.markCentavos = this.data.formattedMarkCentavos
        .replace("R$", "")
        .replace(",", "")
        .replace(".", "")
        .replace(" ", "");

      this.$nextTick(() => {});
    },

    formatReserve: function(sValue) {
      this.data.formattedReserveCentavos = parseInt(
        ("" + sValue).onlyNumber()
      ).int2Money();
      this.data.reserveCentavos = this.data.formattedReserveCentavos
        .replace("R$", "")
        .replace(",", "")
        .replace(".", "")
        .replace(" ", "");

      this.$nextTick(() => {});
    },

    formatAuction: function(sValue) {
      this.data.formattedAuctionCentavos = parseInt(
        ("" + sValue).onlyNumber()
      ).int2Money();
      this.data.auctionCentavos = this.data.formattedAuctionCentavos
        .replace("R$", "")
        .replace(",", "")
        .replace(".", "")
        .replace(" ", "");

      this.$nextTick(() => {});
    },

    formatComission: function(sValue) {
      if (
        sValue === null ||
        sValue === undefined ||
        sValue === "" ||
        sValue === 0
      ) {
        this.data.formattedCommissionPercentual = "% 0,00";
        this.data.commissionPercentualCentavos = "0";
      } else {
        this.data.formattedCommissionPercentual = parseInt(
          ("" + sValue).onlyNumber()
        ).int2Money(2, "% ");
        this.data.commissionPercentualCentavos = this.data.formattedCommissionPercentual
          .replace("%", "")
          .replace("R$", "")
          .replace(",", "")
          .replace(".", "")
          .replace(" ", "");

        console.log(this.data.commissionPercentualCentavos);
      }

      this.$nextTick(() => {});
    },

    initData() {},
  },

  created() {
    this.initData();

    this.$on("execute", () => {
      this.$parent.$emit(this.event, this.data);
    });
  },

  data() {
    return {
      localReadonly: false,
    };
  },
};
</script>
<style scoped lang="scss">
label.stronger {
  font-weight: bold;
  color: black;
}

.stronger {
  font-weight: bold;
  color: black;
  margin: 15px 0 0 0 !important;
}

p.subject {
  color: #9c9c9c;
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Forms/SettingsForm.vue